import React from "react";
import { BsTelephone } from "react-icons/bs";
import { FiMail } from "react-icons/fi";
import {Helmet} from 'react-helmet-async';

const Contact = () => {
  return (
    <>
      <Helmet>
      <title>Contact</title>
      <meta name='description' content="Contact information at Coimbatore International Airport."/>
      <link rel="canonical" href="/contact"/>
    </Helmet>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Shri Kailash Chander Meena, IAP,Airport Director</h5>
          <p className="card-text">
          <BsTelephone/><a href="tel:+4222592155">0381-2342224/9436123556</a>
          </p>
          <p className="card-text">
          <FiMail/>apdagartala@aai.aero
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Airport Terminal Manager</h5>
          <p className="card-text">
          <BsTelephone/> <a href="tel:+9442191902">9402140030</a>
          </p>
          <p className="card-text">
          <FiMail/>tm_agt@aai.aero
          </p>
        </div>
      </div>


      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Public Grievance Officer</h5>
          <p className="card-text">
          <BsTelephone/><a href="tel:+9402140030">9402140030</a>  
          </p>
          <p className="card-text">
          <FiMail/>pgo_agartala@aai.aero
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Lost and Found </h5>
          <p className="card-text">
          <BsTelephone/><a href="tel:+9402140030">9402140030</a>  
          </p>
          <p className="card-text">
          <FiMail/>tm_agt@aai.aero
          </p>
        </div>
      </div>


    </>
  );
};

export default Contact;
